// Resolve SMS API base URL
// Priority: env var -> localStorage override -> dev default -> production same-origin
const envBase = process.env.REACT_APP_SMS_API_URL;
let storedBase;
try { storedBase = localStorage.getItem('sms.apiBase'); } catch (_) { /* noop */ }

function resolveBaseUrl() {
  const configured = envBase || storedBase;
  if (configured) {
    return `${configured}`.replace(/\/$/, '/')
      .replace(/([^:])\/\/$/, '$1/');
  }

  const { hostname, protocol } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8080/';
  }

  // For HTTPS subdomain access, use HTTPS backend
  if (protocol === 'https:' && hostname.includes('caa.co.ug')) {
    return 'https://sms.caa.co.ug:8080/';
  }

  // Production default: point to backend server
  return 'http://10.10.32.45:8080/';
}

const baseURL = resolveBaseUrl();

export default baseURL;
